import React, { Component } from "react";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebProgressbarComponent } from "../common/selltowebprogressbar/SelltoWebProgressbarComponent";

import { VehicleDetailsMMRComponent } from "./VehicleDetailsMMRComponent";

export class VehicleDetailsRouteComponent extends Component {
    pageTitle = "Vehicle Details";

    componentDidMount() {
        let homeData = CommonService.getSessionStorage("homeData");
        try {
            this.props.onPageLoad({ pageTitle: this.pageTitle });
            this.getPageInfo();
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/vehicle-details", pageType: "Consumer", isLoggedIn: "No", properties: { vin: homeData?.vin, tenantName: this.props.tenantName, siteName: this.props.siteName } });
        }
        catch (error) {
            console.logError(error, "VehicleDetailsRouteComponent", "componentDidMount", homeData?.vin);
        }
    }

    getPageInfo() {
        try {
            this.props.applicationInsights.trackTrace({ message: "VehicleDetailsRouteComponent/getPageInfo", properties: { tenantName: this.props.tenantName, siteName: this.props.siteName } });
            fetch("/VehicleDetails/GetPageInfo", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        usePlateToVin: parsedResponse[0].usePlateToVin
                    });
                })
                .catch(notOKResponse => {
                    this.setState({ showSpinner: false });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/VehicleDetails/GetPageInfo", ...parsedError, tenantName: this.props.tenantName, siteName: this.props.siteName } });
                                console.logError(parsedError, "VehicleDetailsRouteComponent", "getPageInfo", this.state.vinOrLicensePlate.toUpperCase());
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "VehicleDetailsRouteComponent", "getPageInfo", this.state.vinOrLicensePlate.toUpperCase());
                            });
                    }
                });
        } catch (error) {
            console.logError(error, "VehicleDetailsRouteComponent", "getPageInfo");
        }
    }

    render() {
        let headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle Details", "Default", "Header Html")?.Value;
        if (!headerHtml) {
            headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Header Html")?.Value ?? "";
        }

        let footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle Details", "Default", "Footer Html")?.Value;
        if (!footerHtml) {
            footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Footer Html")?.Value ?? "";
        }

        return <div className="ac-site ac-vehicledetails">
            <header className="ac-site-header ac-vehicledetails-header" dangerouslySetInnerHTML={{ __html: headerHtml }} />
            <SellToWebProgressbarComponent progressIndex={1} />
            <VehicleDetailsMMRComponent
                siteAttributes={this.props.siteAttributes}
                applicationInsights={this.props.applicationInsights}
            />
            <footer className="ac-site-footer ac-vehicledetails-footer" dangerouslySetInnerHTML={{ __html: footerHtml }} />
        </div>;
    }
}